// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__cardTitle___22Hd2 {\n    margin-bottom: 1em;\n}\n.css__cardBody___2koiK {\n    text-align: center;\n}\n.css__qr_container___3vi7r {\n    position: relative;\n    z-index: 1;\n    display: inline-block;\n}\n.css__qr_container___3vi7r img {\n    opacity: 1;\n    transition: 0.3s;\n}\n.css__qr_container___3vi7r img.css__img_loading___2mHQf {\n    opacity: 0;\n}\n.css__qr_container___3vi7r .css__help_text___15w9d {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    max-width: 90%;\n    transform: translate(-50%, -50%);\n    display: none;\n}\n.css__qr_container___3vi7r img.css__img_loading___2mHQf + .css__help_text___15w9d {\n    display: block;\n}", ""]);
// Exports
exports.locals = {
	"cardTitle": "css__cardTitle___22Hd2",
	"cardBody": "css__cardBody___2koiK",
	"qr_container": "css__qr_container___3vi7r",
	"img_loading": "css__img_loading___2mHQf",
	"help_text": "css__help_text___15w9d"
};
module.exports = exports;
